import React from 'react'

const OperationsAndBenefitsMobile = ({title,IconCard1,IconCard2,IconCard3,IconCard4,firstWordCard1,firstWordCard2,firstWordCard3,firstWordCard4,textCard1,textCard2,textCard3,textCard4,titleCard1,titleCard2,titleCard3,titleCard4,heightText="118px",paddingComponent="45px 0 40px 0"}) => {
  return (
    <div style={{display:"flex",flexDirection:"column",alignItems:"center",padding:paddingComponent,backgroundColor:"rgba(255, 255, 255, 1)"}}>
        
        {title==="Como funciona?" && <h1 className='fz_title_components_owner' style={{textAlign:"center",fontWeight:"600"}}>
           {title}
        </h1>}
        
        {title==="Com a YOLO você tem:" && <span className='fz_title_components_owner' style={{textAlign:"center"}}>
         Com a <span style={{color:"#FF3097"}}> YOLO</span> você tem:
        </span>}

        <div className='display_yolo_coliving' style={{width:"100%",gap:"4%"}}>
            <div className='display_column_yolo_coliving 'style={{paddingLeft:"10%",paddingTop:"30px"}}>
                <img src={IconCard1} alt="IconCard1" className={title === "Com a YOLO você tem:" ? "img_48" : title === "Como funciona?" ? "img_42" : ""}/>
                <div className='display_yolo_coliving' style={{justifyContent:"center",height:"76px"}}>
                    {title === "Como funciona?" && <hr className='hr_operation_yolo' style={{ width: '1px'}}/> }
                </div>
                <img src={IconCard2} alt="IconCard1" className={title === "Com a YOLO você tem:" ? "img_48" : title === "Como funciona?" ? "img_42" : ""}/>
                <div className='display_yolo_coliving' style={{justifyContent:"center",height:"76px"}}>
                    {title === "Como funciona?" && <hr className='hr_operation_yolo' style={{ width: '1px'}}/> }
                </div>
                <img src={IconCard3} alt="IconCard1" className={title === "Com a YOLO você tem:" ? "img_48" : title === "Como funciona?" ? "img_42" : ""}/>
                <div className='display_yolo_coliving' style={{justifyContent:"center",height:"76px"}}>
                    {title === "Como funciona?" && <hr className='hr_operation_yolo' style={{ width: '1px'}}/> }
                </div>
                <img src={IconCard4} alt="IconCard1" className={title === "Com a YOLO você tem:" ? "img_48" : title === "Como funciona?" ? "img_42" : ""}/>
            </div>
            <div className='display_column_yolo_coliving' style={{paddingRight:"4%",paddingTop:"30px"}}>
                <div style={{height:heightText}}>
                    {title==="Com a YOLO você tem:" && <span className='fz_benefits_yolo_mobile' style={{ fontWeight: '700'}}> {titleCard1} </span>}
                    {title==="Com a YOLO você tem:" &&  <br />}
                    <span className='fz_operation_yolo_mobile' style={{color:"#FF3097",fontWeight:"600"}}>
                        {firstWordCard1}
                        <span className={title === "Com a YOLO você tem:" ? "fz_14_important" : ""} style={{color:"#101828",fontWeight:"600"}}>
                            {textCard1}
                        </span>
                    </span>
                </div>
                <div style={{height:heightText}}>
                    {title==="Com a YOLO você tem:" && <span className='fz_benefits_yolo_mobile' style={{ fontWeight: '700'}}> {titleCard2} </span>}
                    {title==="Com a YOLO você tem:" &&  <br />}
                    <span className='fz_operation_yolo_mobile' style={{color:"#FF3097",fontWeight:"600"}}>
                        {firstWordCard2}
                        <span className={title === "Com a YOLO você tem:" ? "fz_14_important" : ""} style={{color:"#101828",fontWeight:"600"}}>
                            {textCard2}
                        </span>
                    </span>
                </div>
                <div style={{height:heightText}}>
                    {title==="Com a YOLO você tem:" && <span className='fz_benefits_yolo_mobile' style={{ fontWeight: '700'}}> {titleCard3} </span>}
                    {title==="Com a YOLO você tem:" &&  <br />}
                    <span className='fz_operation_yolo_mobile' style={{color:"#FF3097",fontWeight:"600"}}>
                        {firstWordCard3}
                        <span className={title === "Com a YOLO você tem:" ? "fz_14_important" : ""} style={{color:"#101828",fontWeight:"600"}}>
                            {textCard3}
                        </span>
                    </span>
                </div>
                <div>
                    {title==="Com a YOLO você tem:" && <span className='fz_benefits_yolo_mobile' style={{ fontWeight: '700'}}> {titleCard4} </span>}
                    {title==="Com a YOLO você tem:" &&  <br />}
                    <span className='fz_operation_yolo_mobile' style={{color:"#FF3097",fontWeight:"600"}}>
                    {firstWordCard4}
                        <span className={title === "Com a YOLO você tem:" ? "fz_14_important" : ""} style={{color:"#101828",fontWeight:"600"}}>
                            {textCard4}
                        </span>
                    </span>
                </div>
            </div>
        </div>
    </div>
  )
}

export default OperationsAndBenefitsMobile